import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { Sponsor } from 'globals/store/sponsors.data';
import { sponsorTemplateReselector } from '../../store/reselectors/entity.reselector';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { ManageContactDetailsComponent } from 'src/app/modules/manage/manage-contact-details.component';
import { ManageCallToActionComponent } from 'src/app/modules/manage/manage-call-to-action.component';

@Component({
    selector: 'manage-template-sponsor',
    templateUrl: './manage-template-sponsor.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, ImageUploaderComponent, ManageSocialLinksComponent, JoiInputComponent, ManageContactDetailsComponent, ManageCallToActionComponent],
})
export class ManageTemplateSponsor extends ManageTemplateWrapper<Sponsor> implements OnInit {
  _file = 'manage-template-sponsor'

  ngOnInit() {
    this.clipboardKey = 'sponsors'
    this.selectProp(sponsorTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId }, 'entity')
  }


}
